import React, { type FC } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

import { selectAuthenticatedNearExpiration, Translation } from '../../../domain'

import { Caption, ClockIcon, Countdown } from '../common'
import { useAppState } from '../State'

const boxStyle: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    height: 24,
    my: 'auto',
    mr: 2,
    px: 2,
    color: 'warning.800',
    backgroundColor: 'warning.100',
    borderColor: 'warning.200',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 1,
    userSelect: 'none',
    whiteSpace: 'nowrap',
}
const iconStyle: SxProps<Theme> = {
    width: 12,
    height: 12,
    color: 'warning.500',
    mr: 1,
}
const captionStyle: SxProps<Theme> = { letterSpacing: 0 }

export const SessionCountdown: FC = () => {
    const nearExpiration = useAppState(selectAuthenticatedNearExpiration)

    if (nearExpiration === null) {
        return null
    }

    return (
        <Box sx={boxStyle} data-testid="session-countdown">
            <ClockIcon sx={iconStyle} />
            <Caption id={Translation.SESSION_COUNTDOWN} values={{ countdown: <Countdown value={nearExpiration} /> }} sx={captionStyle} />
        </Box>
    )
}
